/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
const BasePinView = require('gemini/pinning/PinView');
import ExplorePinsPanel from './PinsPanel';

const PinView = BasePinView.extend({
	_getPinsPanelClass: () => ExplorePinsPanel
});

export default PinView;



// WEBPACK FOOTER //
// ./src/js/glass/extensions/pinning/PinView.js